<script>
import IGAuth from '@/utils/ig/auth.js'
import config from '@/assets/js/config'
import APIConfig from '@/assets/js/data/remote/APIConfig.js'

export default {
  name: 'authIG',
  methods: {
    authIG () {
      let clientID = config.IGClientID
      let redirectUri = APIConfig.IGRedirectUri
      let jwt = this.$services.auth.getJWT()
      let scope = config.IGScope
      return IGAuth.openGetCodePage(clientID, redirectUri, jwt, scope).then(eventData => {
        this.$store.state.admin.Profile.IGUserProfileName = eventData.name
        this.$store.state.admin.Profile.IGAccessTokenExpiredAt = eventData.expiredAt
        // this.form = JSON.parse(JSON.stringify(this.$store.state.admin.Profile))
      })
      // .catch(err=>{
      //   console.error(`authIG`,err)
      // })
    }
  },
  created () {
  }
}
</script>
